export default __webpack_public_path__ + "static/media/mi-file.d4132222.svg";